import request from '@/utils/request'

export function fetchBrand(query) {
  return request({
    url: '/v1/brands',
    method: 'get',
    params: query
  })
}
